let addToCartVisible = false;
let footerVisible = false;

const atcObserver = new IntersectionObserver(
  (entries) => {
    const target = document.querySelector('.sticky-atc');
    if (!target) return;

    entries.forEach((entry) => {
      if (entry.target.id === 'AddToCartButton') {
        addToCartVisible = entry.boundingClientRect.top > 0;        
      } else if (entry.target.classList.contains('site-footer')) {
        footerVisible = entry.isIntersecting;
      }
    });

    // Only show sticky ATC if neither are visible
    if (!addToCartVisible && !footerVisible) {
      target.classList.add('active');
    } else {
      target.classList.remove('active');
    }
  },
  {
    threshold: 0.25,
  }
);

// Elements to observe
window.addEventListener('load', () => {
  const addToCartBtn = document.querySelector('#AddToCartButton');
  const footer = document.querySelector('.site-footer');

  if (addToCartBtn) atcObserver.observe(addToCartBtn);
  if (footer) atcObserver.observe(footer);
});

document.querySelectorAll('.sticky-atc__trigger').forEach((item) => {
  item.addEventListener('click', function () {
    const target = document.querySelector('.sticky-atc__container');
    if (target !== null) {
      target.classList.toggle('active');
    }
  });
});

if (document.querySelector('.gallery-zoom')) {
  const zoom_container = document.querySelector('.gallery-zoom');

  document.querySelectorAll('.product__media-item:not(.media-video)').forEach((item) => {
    item.addEventListener('click', function () {
      let img = item.querySelector('img').src.replace('&width=1440', '&width=2048');

      document.body.classList.add('drawer--open');
      zoom_container.classList.add('gallery-zoom--active');
      zoom_container.querySelector('img').src = img;
    });
  });

  zoom_container.addEventListener('click', function () {
    document.body.classList.remove('drawer--open');
    zoom_container.classList.remove('gallery-zoom--active');
  });
}
